import React from 'react';
import './TileView.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCalendar } from '@fortawesome/free-solid-svg-icons';

const TileView = ({ users, loading }) => {
    if (loading) {
        return <h2>Loading...</h2>
    }
    return (
        <div className="row g-4 my-4">
            {users.map((user) =>
                <div className="col">
                    <div className="user-card  d-flex">
                        <div>
                            <img src={user.picture.medium} className="rounded-circle m-4 h-50" alt="..." />
                        </div>
                        <div className="mt-3">
                            <h5>{user.name.last}, {user.name.first}</h5>
                            <p className="text-muted">{user.email}</p>
                            <p><FontAwesomeIcon icon={faUser} className="me-2" />{user.login.username}</p>
                            <p><FontAwesomeIcon icon={faCalendar} className="me-2" />{user.registered.date}</p>
                        </div>
                    </div>
                </div>
            )}
        </div>

    );
};

export default TileView;